module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"root":["calendarUtils"],"commonjs":"calendar-utils","commonjs2":"calendar-utils","amd":"calendar-utils"}
// module id = 4
// module chunks = 0